// source: proto/base_types.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_descriptor_pb = require('google-protobuf/google/protobuf/descriptor_pb.js');
goog.object.extend(proto, google_protobuf_descriptor_pb);
goog.exportSymbol('proto.ic_base_types.pb.v1.PrincipalId', null, global);
goog.exportSymbol('proto.ic_base_types.pb.v1.tuiSignedDisplayQ22021', null, global);
goog.exportSymbol('proto.ic_base_types.pb.v1.tuiSignedMessage', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ic_base_types.pb.v1.PrincipalId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ic_base_types.pb.v1.PrincipalId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ic_base_types.pb.v1.PrincipalId.displayName = 'proto.ic_base_types.pb.v1.PrincipalId';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ic_base_types.pb.v1.PrincipalId.prototype.toObject = function(opt_includeInstance) {
  return proto.ic_base_types.pb.v1.PrincipalId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ic_base_types.pb.v1.PrincipalId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ic_base_types.pb.v1.PrincipalId.toObject = function(includeInstance, msg) {
  var f, obj = {
    serializedId: msg.getSerializedId_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ic_base_types.pb.v1.PrincipalId}
 */
proto.ic_base_types.pb.v1.PrincipalId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ic_base_types.pb.v1.PrincipalId;
  return proto.ic_base_types.pb.v1.PrincipalId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ic_base_types.pb.v1.PrincipalId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ic_base_types.pb.v1.PrincipalId}
 */
proto.ic_base_types.pb.v1.PrincipalId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSerializedId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ic_base_types.pb.v1.PrincipalId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ic_base_types.pb.v1.PrincipalId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ic_base_types.pb.v1.PrincipalId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ic_base_types.pb.v1.PrincipalId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerializedId_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes serialized_id = 1;
 * @return {!(string|Uint8Array)}
 */
proto.ic_base_types.pb.v1.PrincipalId.prototype.getSerializedId = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes serialized_id = 1;
 * This is a type-conversion wrapper around `getSerializedId()`
 * @return {string}
 */
proto.ic_base_types.pb.v1.PrincipalId.prototype.getSerializedId_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSerializedId()));
};


/**
 * optional bytes serialized_id = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSerializedId()`
 * @return {!Uint8Array}
 */
proto.ic_base_types.pb.v1.PrincipalId.prototype.getSerializedId_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSerializedId()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.ic_base_types.pb.v1.PrincipalId} returns this
 */
proto.ic_base_types.pb.v1.PrincipalId.prototype.setSerializedId = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};



/**
 * A tuple of {field number, class constructor} for the extension
 * field named `tuiSignedMessage`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.ic_base_types.pb.v1.tuiSignedMessage = new jspb.ExtensionFieldInfo(
    20000,
    {tuiSignedMessage: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[20000] = new jspb.ExtensionFieldBinaryInfo(
    proto.ic_base_types.pb.v1.tuiSignedMessage,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[20000] = proto.ic_base_types.pb.v1.tuiSignedMessage;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `tuiSignedDisplayQ22021`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.ic_base_types.pb.v1.tuiSignedDisplayQ22021 = new jspb.ExtensionFieldInfo(
    20001,
    {tuiSignedDisplayQ22021: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[20001] = new jspb.ExtensionFieldBinaryInfo(
    proto.ic_base_types.pb.v1.tuiSignedDisplayQ22021,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[20001] = proto.ic_base_types.pb.v1.tuiSignedDisplayQ22021;

goog.object.extend(exports, proto.ic_base_types.pb.v1);
